/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Layers_PersonalInputs */

const cs_integrations_layers_personal = /** @type {(inputs: Integrations_Layers_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení Google/Microsoft a iCal jsou na Profilu. Seller persona makléře se řeší v Uživatelích — není to druhé heslo RK.`)
};

const en_integrations_layers_personal = /** @type {(inputs: Integrations_Layers_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google/Microsoft sign-in and iCal live on Profile. Each broker’s Sreality seller persona is attached on Users — not a second RK password.`)
};

/**
* | output |
* | --- |
* | "Google/Microsoft sign-in and iCal live on Profile. Each broker’s Sreality seller persona is attached on Users — not a second RK password." |
*
* @param {Integrations_Layers_PersonalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_layers_personal = /** @type {((inputs?: Integrations_Layers_PersonalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Layers_PersonalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_layers_personal(inputs)
	return cs_integrations_layers_personal(inputs)
});